var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-method-afip-information"},[_c('payment-method'),_c('afip-information'),_c('employee'),_c('caja'),_c('select-address'),_c('sale-type'),_c('seller'),_c('cuotas')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }